import { render, staticRenderFns } from "./ContratoOperadora.vue?vue&type=template&id=12a315bd&"
import script from "./ContratoOperadora.vue?vue&type=script&lang=js&"
export * from "./ContratoOperadora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports